import { useEffect } from 'react';

export function useVersionCheck() {
  useEffect(() => {
    let currentVersion = localStorage.getItem('app-version');

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-cache' });
        const { version } = await res.json();

        if (currentVersion && currentVersion !== version) {
          console.warn('New build detected — refreshing...');
          window.location.reload(true);
        }

        localStorage.setItem('app-version', version);
        currentVersion = version;
      } catch (err) {
        // ignore
      }
    };

    // Check on load
    checkVersion();

    // Check on tab focus
    window.addEventListener('focus', checkVersion);
    return () => window.removeEventListener('focus', checkVersion);
  }, []);
}
